import { faker } from '@faker-js/faker';
import { Document } from '@quadminds/client-apis/agents';
import { ANALIZE_STATUS } from '../../enums/analize.enum';

export const generateDocumentFaker = (): Document => {
    return {
        _id: faker.database.mongodbObjectId(),
        title: `Informe Financiero ${faker.date.month()} ${faker.date.recent().getFullYear()}`,
        name: `${faker.system.fileName()}.${faker.system.fileExt()}`,
        status: faker.helpers.arrayElement(Object.values(ANALIZE_STATUS)),
        active: faker.datatype.boolean(),
        summary: faker.lorem.paragraph(),
        tags: faker.helpers.arrayElements(
            ['finanzas', 'reportes trimestrales', 'análisis financiero', 'proyecciones', 'costos', 'ganancias'],
            faker.datatype.number({ min: 2, max: 4 }),
        ),
        chunk_count: faker.datatype.number({ min: 5, max: 50 }),
        uploaded_by: {
            userId: faker.name.fullName(),
            fullName: faker.name.fullName(),
            photo: faker.image.avatar(),
        },
        owner_id: faker.database.mongodbObjectId(),
        organization_id: faker.database.mongodbObjectId(),
        created_at: faker.date.past().toISOString(),
        updated_at: faker.date.recent().toISOString(),
        processing_time_ms: faker.datatype.number({ min: 1000, max: 5000 }),
        processing_metadata: {
            processing_status: faker.helpers.arrayElement(['complete', 'pending', 'failed']),
        },
        content_metadata: {
            page_count: faker.datatype.number({ min: 5, max: 100 }),
            word_count: faker.datatype.number({ min: 1000, max: 15000 }),
            character_count: faker.datatype.number({ min: 5000, max: 100000 }),
            language: faker.helpers.arrayElement(['es', 'en', 'fr']),
            entities: Array.from({ length: faker.datatype.number({ min: 2, max: 5 }) }, () => ({
                type: faker.helpers.arrayElement(['organization', 'person', 'location', 'date']),
                value: faker.company.name(),
                count: faker.datatype.number({ min: 1, max: 50 }),
            })),
        },
    };
};

export const generateDocumentListFaker = (count: number): Document[] => {
    return Array.from({ length: count }, generateDocumentFaker);
};
